export const styles = {
  container: {
    mt: 2,
    mb: 2
  },
  progressBar: {
    height: 8,
    borderRadius: 4,
    mb: 2
  },
  requirementsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1
  },
  requirementItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    fontSize: '1.1rem'
  },
  requirementText: {
    fontSize: '1.1rem'
  }
};
